import React from 'react';
import { Helmet } from 'react-helmet';
import Navbar from './Navbar';
import Footer from './Footer';

const NotFound = () => {
    return (
        <>
            <Helmet>
                <title>404 - Page Not Found | Book Witch</title>
                <meta name="description" content="The page you are looking for does not exist." />
            </Helmet>
            <Navbar />
            <div className="not-found-container">
                <h1>404 - Page Not Found</h1>
                <p>The page you are looking for does not exist or has been moved.</p>
                <a href="/" className="button-primary">Return to Home</a>
            </div>
            <Footer />
        </>
    );
};

export default NotFound; 